import React from "react";
import cone from "../../assets/cone.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
function DummySuccess() {
    const [counter, setCounter] = useState(2);
    const Navigate = useNavigate();
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCounter((prevCounter) => prevCounter - 1);
    //     }, 1000);

    //     return () => {
    //         clearInterval(interval);
    //     };
    // }, []); // Run the effect only once when the component mounts

    // useEffect(() => {
    //     if (counter === 0) {
    //         // window.close();
    //         if (localStorage.getItem("token")) {
    //             Navigate("/dashboard/deposits");
    //         } else {
    //             let recId = localStorage.getItem("recId");
    //             if (recId) {
    //                 Navigate(`/payment/${recId}`);
    //             } else {
    //                 Navigate(`/`);
    //             }
    //         }
    //     }
    // }, [counter]);
    return (
        <div className="dummy-success">
            <div className="success-modal-custom">
                <img src={cone} alt="success" width={"200px"} />
                <h3>Your Transaction is successful!</h3>
                <p>
                    You will be receiving a Confirmation email with order
                    details
                </p>
                {/* <p style={{ textDecoration: "underline" }}>
                    closes in {counter}
                </p> */}
            </div>
        </div>
    );
}

export default DummySuccess;
